var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      staticClass: "invoice-dashboard",
      attrs: { title: _vm.$t("lbl_invoice_recurring_report") }
    },
    [
      _c(
        "a-form-model",
        {
          ref: "formModel",
          staticClass: "mb-4",
          attrs: {
            model: _vm.form,
            "wrapper-col": { span: 12 },
            "label-col": { span: 6 },
            "label-align": "left",
            rules: _vm.validationSchema
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: [16, 16] } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: _vm.$t("lbl_period_date"), prop: "date" }
                    },
                    [
                      _c("a-range-picker", {
                        attrs: {
                          format: _vm.DEFAULT_DATE_FORMAT,
                          placeholder: [
                            _vm.$t("lbl_start_date"),
                            _vm.$t("lbl_end_date")
                          ]
                        },
                        model: {
                          value: _vm.form.date,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: _vm.$t("lbl_customer"), prop: "customer" }
                    },
                    [
                      _c("SelectCustomer", {
                        attrs: { "label-in-value": "" },
                        model: {
                          value: _vm.form.customer,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customer", $$v)
                          },
                          expression: "form.customer"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-space",
                    [
                      _c("a-button", { on: { click: _vm.handleReset } }, [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_reset")) + " ")
                      ]),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loading.find,
                            "html-type": "submit"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_find")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading.find
        ? [
            _c(
              "div",
              { staticClass: "invoice-dashboard__kpi-skeleton" },
              _vm._l(5, function(i) {
                return _c(
                  "div",
                  { key: i, staticClass: "invoice-dashboard__kpi-item" },
                  [
                    _c("div", {
                      staticClass:
                        "invoice-dashboard__skeleton invoice-dashboard__skeleton--label"
                    }),
                    _c("div", {
                      staticClass:
                        "invoice-dashboard__skeleton invoice-dashboard__skeleton--value"
                    })
                  ]
                )
              }),
              0
            ),
            _vm._l(3, function(i) {
              return _c(
                "div",
                {
                  key: "customer-" + i,
                  staticClass: "invoice-dashboard__customer-skeleton"
                },
                [
                  _c(
                    "div",
                    { staticClass: "invoice-dashboard__customer-header" },
                    [
                      _c("div", {
                        staticClass:
                          "invoice-dashboard__skeleton invoice-dashboard__skeleton--name"
                      }),
                      _c("div", {
                        staticClass:
                          "invoice-dashboard__skeleton invoice-dashboard__skeleton--metric"
                      }),
                      _c("div", {
                        staticClass:
                          "invoice-dashboard__skeleton invoice-dashboard__skeleton--metric"
                      }),
                      _c("div", {
                        staticClass:
                          "invoice-dashboard__skeleton invoice-dashboard__skeleton--tag"
                      })
                    ]
                  )
                ]
              )
            })
          ]
        : !_vm.dashboard || !_vm.dashboard.customers.length
        ? _c(
            "div",
            { staticClass: "invoice-dashboard__empty" },
            [
              _c("a-icon", {
                staticClass: "invoice-dashboard__empty-icon",
                attrs: { type: "file" }
              }),
              _c("div", { staticClass: "invoice-dashboard__empty-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("notif_data_not_found")) + " ")
              ])
            ],
            1
          )
        : [
            _c("div", { staticClass: "invoice-dashboard__kpi" }, [
              _c("div", { staticClass: "invoice-dashboard__kpi-item" }, [
                _c("div", { staticClass: "invoice-dashboard__kpi-label" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lbl_total_invoice_amount_dpp")) + " "
                  )
                ]),
                _c("div", { staticClass: "invoice-dashboard__kpi-value" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("currency")(_vm.dashboard.totalInvoiceAmount)
                      ) +
                      " "
                  )
                ])
              ]),
              _c("div", { staticClass: "invoice-dashboard__kpi-item" }, [
                _c("div", { staticClass: "invoice-dashboard__kpi-label" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("lbl_total_outstanding_dpp")) + " "
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "invoice-dashboard__kpi-value invoice-dashboard__kpi-value--amber"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("currency")(_vm.dashboard.totalOutstanding)
                        ) +
                        " "
                    )
                  ]
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "invoice-dashboard__list-header" },
              [
                _c(
                  "a-button",
                  { attrs: { size: "small" }, on: { click: _vm.toggleAll } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isAllCollapsed
                            ? _vm.$t("lbl_expand_all")
                            : _vm.$t("lbl_collapse_all")
                        ) +
                        " "
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "invoice-dashboard__customer-list" },
              _vm._l(_vm.dashboard.customers, function(customer) {
                return _c(
                  "div",
                  {
                    key: customer.customerId,
                    staticClass: "invoice-dashboard__customer",
                    class: {
                      "invoice-dashboard__customer--collapsed": _vm.isCollapsed(
                        customer.customerId
                      )
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "invoice-dashboard__customer-header",
                        on: {
                          click: function($event) {
                            return _vm.toggleCustomer(customer.customerId)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "invoice-dashboard__customer-name" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "invoice-dashboard__customer-icon"
                              },
                              [_vm._v("▼")]
                            ),
                            _vm._v(" " + _vm._s(customer.customerName) + " "),
                            _c(
                              "span",
                              {
                                staticClass: "invoice-dashboard__customer-count"
                              },
                              [
                                _vm._v(
                                  " (" +
                                    _vm._s(
                                      _vm.$t("lbl_contracts_count", {
                                        count: customer.contractCount
                                      })
                                    ) +
                                    ") "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "invoice-dashboard__customer-column" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "invoice-dashboard__customer-column-label"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("lbl_invoiced_dpp")) + " "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "invoice-dashboard__customer-column-value invoice-dashboard__customer-column-value--invoiced"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        customer.totalInvoiceAmount
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "invoice-dashboard__customer-column" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "invoice-dashboard__customer-column-label"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("lbl_outstanding_dpp")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "invoice-dashboard__customer-column-value invoice-dashboard__customer-column-value--outstanding"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        customer.totalOutstanding
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    !_vm.isCollapsed(customer.customerId)
                      ? _c(
                          "div",
                          { staticClass: "invoice-dashboard__table-wrap" },
                          [
                            _c(
                              "table",
                              { staticClass: "invoice-dashboard__table" },
                              [
                                _c("colgroup", [
                                  _c("col", {
                                    staticStyle: { width: "160px" }
                                  }),
                                  _c("col", {
                                    staticStyle: { width: "200px" }
                                  }),
                                  _c("col", {
                                    staticStyle: { width: "160px" }
                                  }),
                                  _c("col", {
                                    staticStyle: { width: "160px" }
                                  }),
                                  _c("col", { staticStyle: { width: "120px" } })
                                ]),
                                _c("thead", [
                                  _c("tr", [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "invoice-dashboard__table-head"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("lbl_ic_number")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "invoice-dashboard__table-head"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("lbl_rent_period")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "invoice-dashboard__table-head",
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("lbl_invoiced")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "invoice-dashboard__table-head",
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("lbl_outstanding")) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "invoice-dashboard__table-head"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("lbl_status")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(customer.contracts, function(
                                    contract
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        key: contract.icId,
                                        staticClass:
                                          "invoice-dashboard__table-row"
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "invoice-dashboard__table-cell"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__link",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openDetail(
                                                      contract
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(contract.icNo) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "invoice-dashboard__table-cell invoice-dashboard__table-cell--rent"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  contract.rentPeriodRange
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "invoice-dashboard__table-cell invoice-dashboard__table-cell--currency invoice-dashboard__table-cell--invoiced"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    contract.subtotalInvoiceAmount
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "invoice-dashboard__table-cell invoice-dashboard__table-cell--currency invoice-dashboard__table-cell--outstanding"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    contract.subtotalOutstanding
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "invoice-dashboard__table-cell"
                                          },
                                          [
                                            _c(
                                              "a-tag",
                                              {
                                                attrs: {
                                                  color: _vm.getStatusColor(
                                                    contract.icStatus
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(contract.icStatus) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _c(
              "Modal",
              {
                attrs: {
                  showmodal: _vm.show.detail,
                  idmodal: "invoice-dashboard-detail",
                  title: _vm.selected ? _vm.selected.icNo : "",
                  width: 800
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "contentmodal" }, slot: "contentmodal" },
                  [
                    _vm.selected
                      ? [
                          _c(
                            "div",
                            { staticClass: "invoice-dashboard__kpi--detail" },
                            [
                              _c(
                                "div",
                                { staticClass: "invoice-dashboard__kpi-item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-dashboard__kpi-label"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("lbl_invoice_amount_dpp")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-dashboard__kpi-value"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.selected.subtotalInvoiceAmount
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "invoice-dashboard__kpi-item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-dashboard__kpi-label"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("lbl_outstanding_dpp")
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-dashboard__kpi-value invoice-dashboard__kpi-value--amber"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.selected.subtotalOutstanding
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "invoice-dashboard__table-wrap" },
                            [
                              _vm.selected.lines
                                ? _c(
                                    "table",
                                    { staticClass: "invoice-dashboard__table" },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("lbl_no")) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("lbl_unit")) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("lbl_period")) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("lbl_invoice")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("lbl_status")) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head",
                                              staticStyle: {
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("lbl_amount")) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass:
                                                "invoice-dashboard__table-head",
                                              staticStyle: {
                                                "text-align": "right"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("lbl_outstanding")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _c(
                                        "tbody",
                                        {
                                          staticClass:
                                            "invoice-dashboard__table-row"
                                        },
                                        _vm._l(_vm.selected.lines, function(
                                          line
                                        ) {
                                          return _c("tr", { key: line.no }, [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell"
                                              },
                                              [_vm._v(_vm._s(line.no))]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(line.unitCode) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(line.period) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      line.invoiceArNo || "-"
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell"
                                              },
                                              [
                                                _c(
                                                  "a-tag",
                                                  {
                                                    attrs: {
                                                      color: _vm.getStatusColor(
                                                        line.arStatus
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          line.invoiceArStatus ||
                                                            "NOT INVOICED"
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell invoice-dashboard__table-cell--currency invoice-dashboard__table-cell--invoiced"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        line.invoiceAmount
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "invoice-dashboard__table-cell invoice-dashboard__table-cell--currency invoice-dashboard__table-cell--outstanding"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        line.outstanding
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "div",
                  { attrs: { slot: "footermodal" }, slot: "footermodal" },
                  [
                    _c(
                      "a-button",
                      { key: "close", on: { click: _vm.handleCloseModal } },
                      [_vm._v(" " + _vm._s(_vm.$t("lbl_close")) + " ")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }